export default [
  {
    path: '/ban-show',
    component: () => import('./Page.vue'),
    meta: { title: '封禁公示', id: 23 },
  },
]
